import { Separator } from "@/components/ui/separator";
import { Lightbulb } from "lucide-react";

interface HelpTextPreviewProps {
  fieldName: string;
  helpText: string;
  isMultiSelect: boolean;
}

export const HelpTextPreview = ({ fieldName, helpText, isMultiSelect }: HelpTextPreviewProps) => {
  // Process the help text to replace variables
  const processedText = helpText
    .replace(/{fieldName}/g, fieldName.toLowerCase())
    .replace(/{isMultiSelect}/g, isMultiSelect ? "true" : "false");

  return (
    <div className="mt-6 mb-3">
      <Separator className="mb-4" />
      <div className="flex items-start gap-2 text-sm text-muted-foreground">
        <Lightbulb className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
        <p className="flex-1">💡 Tip: {processedText}</p>
      </div>
    </div>
  );
};
